import { createEvent, createEffect, createStore, sample } from 'effector';
import { DiContainer } from '@@/di/di-container';
import { AuthService } from '@@/auth/services/auth.service';
import { IRootAuth } from '../ts';

const authService = DiContainer.get(AuthService);

export const checkAuth = createEvent('checkAuth');
export const checkAuthFx = createEffect('checkAuthFx', {
  handler: () => authService.checkAuth(),
});

sample({
  source: checkAuth,
  target: checkAuthFx,
});

export const logout = createEvent('logout');
export const switchDisplayBuySubscription = createEvent<boolean>();

export const $isAuthorized = createStore(false, { name: 'isAuthorized' });
export const $isSubscribed = createStore<boolean | null>(null).on(
  checkAuthFx.doneData,
  (_state, payload) => {
    return payload.isSubscribed;
  },
);
export const $displayBuySubscription = createStore<boolean>(false).on(
  switchDisplayBuySubscription,
  (_s, p) => {
    return p;
  },
);

const userPermissionsInitialState = {
  calculator: false,
  mix: false,
  profile: false,
  storage: false,
  search: false,
  transactions: false,
};
export const $userPermissions = createStore(userPermissionsInitialState);
export const $userData = createStore<IRootAuth | null>(null).on(
  checkAuthFx.doneData,
  (_s, p) => {
    localStorage.setItem('USER_ID', String(p.id));
    return p;
  },
);

sample({
  source: checkAuthFx.doneData,
  target: $isAuthorized,
  fn: (data) => data.isValid,
});

sample({
  source: checkAuthFx.doneData,
  target: $userPermissions,
  fn: (data) => ({
    calculator: data?.permission?.calculator || false,
    mix: data?.permission?.mix || false,
    profile: data?.permission?.profile || false,
    storage: data?.permission?.storage || false,
    search: data?.permission?.search || false,
    transactions: data?.permission?.transactions || false,
  }),
});

sample({
  source: logout,
  target: $isAuthorized,
  fn: () => false,
});

sample({
  source: logout,
  target: $isSubscribed,
  fn: () => false,
});

sample({
  source: logout,
  target: $userPermissions,
  fn: () => userPermissionsInitialState,
});

sample({
  source: logout,
  target: $userData,
  fn: () => null,
});

export const $isAuthorizing = checkAuthFx.pending;
export const $isBuyerConfirming = '';
